var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.tituloPagina))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{on:{"click":_vm.updateData}},[_vm._v("Actualizar")]),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081a7d86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/reportes/LicenciasByArticulo.vue
// module id = Vk+a
// module chunks = 1